"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var Swipeable = require("react-swipeable");
var ReactModal = require("react-modal");
var react_tracking_1 = require("react-tracking");
var bind_1 = require("../bind");
var is_node_1 = require("../is-node");
var tracker_1 = require("../tracker");
var lightbox_image_item_1 = require("./lightbox_image_item");
var LIGHTBOX_OUTLET = '.modal-outlet__lightbox';
var LEFT_ARROW_CODE = 37;
var RIGHT_ARROW_CODE = 39;
var COMPONENT_NAME = 'LightboxImage';
var INTERACTIONS = {
    SCROLL: 'scroll',
    CLICK_THUMBNAIL: 'click_thumbnail',
    OPEN_MODAL: 'open_modal',
    VIEW_VIDEO: 'view_video',
};
var LightboxImage = /** @class */ (function (_super) {
    tslib_1.__extends(LightboxImage, _super);
    function LightboxImage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeImgIndex: 0,
            aspectOverride: null,
            isOpen: false,
            imageLoading: false,
            displayVideo: false,
            primaryImageLoaded: false,
            transitioning: false,
        };
        // Element to add `aria-hidden` to when modal is open. This should really
        // be a child of body, but our layout doesn't have a single container element.
        // https://reactcommunity.org/react-modal/examples/set_app_element.html
        ReactModal.setAppElement('body');
        return _this;
    }
    LightboxImage.prototype.componentDidMount = function () {
        if (this.props.persistKeystrokes) {
            window.addEventListener('keydown', this.handleKeyDown);
        }
    };
    LightboxImage.prototype.outlet = function () {
        return document.querySelector(LIGHTBOX_OUTLET) || document.body;
    };
    LightboxImage.prototype.handleMainImageClick = function (evt, idx) {
        evt.preventDefault();
        if (this.isLink(this.props.fullsizeURLs[idx]) && !this.props.disableFullScreen) {
            this.openModal(idx);
            return;
        }
        if (!this.isLink(this.props.fullsizeURLs[idx])) {
            this.setState({ displayVideo: true });
            this.trackVideoView();
        }
    };
    LightboxImage.prototype.closeModal = function () {
        this.setState({
            isOpen: false,
            displayVideo: false,
        });
        if (!this.props.persistKeystrokes) {
            window.removeEventListener('keydown', this.handleKeyDown);
        }
    };
    LightboxImage.prototype.handleImageLoaded = function () {
        this.setState({ imageLoading: false });
    };
    LightboxImage.prototype.handlePrimaryImageLoaded = function (evt) {
        if (!this.state.primaryImageLoaded && this.props.useAspectOverride) {
            this.setState({
                aspectOverride: evt.target.height / evt.target.width,
            });
        }
        this.setState({ primaryImageLoaded: true });
    };
    LightboxImage.prototype.handleKeyDown = function (e) {
        if (this.isSingleImage() || e.ctrlKey || e.metaKey || e.altKey) {
            return;
        }
        if (e.keyCode === LEFT_ARROW_CODE) {
            this.loadPrevImage(e);
        }
        if (e.keyCode === RIGHT_ARROW_CODE) {
            this.loadNextImage(e);
        }
    };
    LightboxImage.prototype.loadNextImage = function (e) {
        var newIdx = this.state.activeImgIndex + 1;
        e.stopPropagation();
        this.setState({
            activeImgIndex: newIdx >= this.props.fullsizeURLs.length ? 0 : newIdx,
            displayVideo: false,
            imageLoading: true,
        });
        this.trackScroll();
    };
    LightboxImage.prototype.loadPrevImage = function (e) {
        var newIdx = this.state.activeImgIndex - 1;
        e.stopPropagation();
        this.setState({
            activeImgIndex: newIdx >= 0 ? newIdx : this.props.fullsizeURLs.length - 1,
            displayVideo: false,
            imageLoading: true,
        });
        this.trackScroll();
    };
    LightboxImage.prototype.handleFullsizeImageClick = function (evt, idx) {
        evt.stopPropagation();
        if (!this.isLink(this.props.fullsizeURLs[idx])) {
            this.setState({ displayVideo: true });
            this.trackVideoView();
        }
    };
    LightboxImage.prototype.handleThumbClick = function (evt, idx) {
        evt.preventDefault();
        this.setState({ displayVideo: false });
        if (this.state.activeImgIndex === idx)
            return false;
        if (this.props.imageURLs) {
            this.setState({
                transitioning: true,
                activeImgIndex: idx,
            });
            this.trackThumbnailClick();
            setTimeout(this.resetTransition, 50);
            return null;
        }
        this.openModal(idx);
    };
    LightboxImage.prototype.isLink = function (url) {
        return url.slice(0, 4) === 'http';
    };
    LightboxImage.prototype.resetTransition = function () {
        this.setState({
            transitioning: false,
        });
    };
    LightboxImage.prototype.openModal = function (idx) {
        if (!this.props.persistKeystrokes) {
            window.addEventListener('keydown', this.handleKeyDown);
        }
        this.setState({
            isOpen: true,
            activeImgIndex: idx,
        });
        this.trackModalOpen();
    };
    LightboxImage.prototype.getImageAlt = function (idx) {
        if (!this.props.imageAlts) {
            return null;
        }
        return this.props.imageAlts[idx];
    };
    LightboxImage.prototype.isActiveThumb = function (idx) {
        return this.state.activeImgIndex === idx;
    };
    LightboxImage.prototype.isSingleImage = function () {
        return this.props.fullsizeURLs.length === 1;
    };
    LightboxImage.prototype.hasFullSizeImages = function () {
        return this.props.fullsizeURLs && this.props.fullsizeURLs.length > 0;
    };
    LightboxImage.prototype.shouldRenderControls = function () {
        return this.props.withControls && !this.isSingleImage();
    };
    LightboxImage.prototype.shouldDisplayThumbnails = function () {
        if (this.props.hideThumbs)
            return false;
        if (this.props.imageURLs) {
            return this.props.thumbURLs && this.props.thumbURLs.length > 1;
        }
        return this.props.thumbURLs && this.props.thumbURLs.length > 0;
    };
    LightboxImage.prototype.renderCaption = function () {
        if (!(this.props.captionText && !!this.props.captionText.length)) {
            return null;
        }
        return (React.createElement("div", { className: "lightbox-modal__caption" }, this.props.captionText));
    };
    LightboxImage.prototype.trackScroll = function () {
        this.props.tracking.trackEvent({
            eventType: tracker_1.INTERACTION,
            interactionType: INTERACTIONS.SCROLL,
            context: {
                modal: this.state.isOpen,
            },
        });
    };
    LightboxImage.prototype.trackModalOpen = function () {
        this.props.tracking.trackEvent({
            eventType: tracker_1.INTERACTION,
            interactionType: INTERACTIONS.OPEN_MODAL,
        });
    };
    LightboxImage.prototype.trackVideoView = function () {
        this.props.tracking.trackEvent({
            eventType: tracker_1.INTERACTION,
            interactionType: INTERACTIONS.VIEW_VIDEO,
            context: {
                modal: this.state.isOpen,
            },
        });
    };
    LightboxImage.prototype.trackThumbnailClick = function () {
        this.props.tracking.trackEvent({
            eventType: tracker_1.INTERACTION,
            interactionType: INTERACTIONS.CLICK_THUMBNAIL,
        });
    };
    LightboxImage.prototype.renderThumb = function (urlOrSlug, idx) {
        var thumbClass = classNames('lightbox-image__thumb', { 'lightbox-image__thumb--inactive': !this.isActiveThumb(idx) });
        return (React.createElement("div", { className: thumbClass, key: idx },
            React.createElement(lightbox_image_item_1.default, { urlOrSlug: urlOrSlug, index: idx, alt: this.getImageAlt(idx), onClick: this.handleThumbClick })));
    };
    LightboxImage.prototype.renderThumbs = function () {
        var _this = this;
        if (!this.props.thumbURLs)
            return null;
        return (React.createElement("div", { className: "lightbox-image__thumbs" },
            React.createElement("div", { className: "lightbox-image__thumbs__inner" }, this.props.thumbURLs.map(function (thumbURL, idx) { return _this.renderThumb(thumbURL, idx); }))));
    };
    LightboxImage.prototype.renderControls = function () {
        if (this.isSingleImage())
            return null;
        return (React.createElement("div", { "data-controls": true },
            React.createElement("button", { className: "lightbox-image__control lightbox-image__control--next", onClick: this.loadNextImage, "aria-label": "Next Image" }),
            React.createElement("button", { className: "lightbox-image__control lightbox-image__control--prev", onClick: this.loadPrevImage, "aria-label": "Previous Image" })));
    };
    LightboxImage.prototype.renderPrimary = function () {
        var urlOrSlug = this.props.imageURLs[this.state.activeImgIndex];
        return (React.createElement(lightbox_image_item_1.default, { urlOrSlug: urlOrSlug, index: this.state.activeImgIndex, alt: this.getImageAlt(this.state.activeImgIndex), onClick: this.handleMainImageClick, onLoad: this.handlePrimaryImageLoaded, controls: this.props.withControls && this.renderControls(), renderVideo: !this.state.isOpen && this.state.displayVideo, aspectOverride: this.state.aspectOverride }));
    };
    LightboxImage.prototype.renderPrimaryCaption = function () {
        var alt = this.getImageAlt(this.state.activeImgIndex);
        if (!this.props.showAltsAsCaptions || !alt)
            return null;
        return (React.createElement("div", { className: "lightbox-image__primary__caption" }, alt));
    };
    LightboxImage.prototype.renderPrimarySwipeContainer = function () {
        if (!this.props.imageURLs)
            return null;
        if (this.isSingleImage() || !this.shouldDisplayThumbnails()) {
            return (React.createElement("div", { className: "lightbox-image__primary" }, this.renderPrimary()));
        }
        return (React.createElement("div", { className: "lightbox-image__primary" },
            React.createElement(Swipeable, { onSwipedLeft: this.loadNextImage, onSwipedRight: this.loadNextImage }, this.renderPrimary())));
    };
    LightboxImage.prototype.renderFullsizeImage = function () {
        return (React.createElement(lightbox_image_item_1.default, { urlOrSlug: this.props.fullsizeURLs[this.state.activeImgIndex], alt: this.getImageAlt(this.state.activeImgIndex), onLoad: this.handleImageLoaded, onClick: this.handleFullsizeImageClick, renderVideo: this.state.displayVideo, index: this.state.activeImgIndex }));
    };
    LightboxImage.prototype.renderSwipeContainer = function () {
        if (this.isSingleImage()) {
            return this.renderFullsizeImage();
        }
        return (React.createElement(Swipeable, { onSwipedLeft: this.loadNextImage, onSwipedRight: this.loadNextImage }, this.renderFullsizeImage()));
    };
    LightboxImage.prototype.renderImageForCache = function (image, i) {
        return (React.createElement("img", { src: image, key: i }));
    };
    LightboxImage.prototype.renderImageCache = function () {
        var _this = this;
        if (!this.state.primaryImageLoaded)
            return;
        return (React.createElement("div", { className: "d-none" }, this.props.imageURLs.map(function (image, i) { return _this.renderImageForCache(image, i); })));
    };
    LightboxImage.prototype.renderCloseButton = function () {
        return (React.createElement("button", { type: "button", onClick: this.closeModal, className: "lightbox-modal__close" }));
    };
    LightboxImage.prototype.render = function () {
        if (!this.hasFullSizeImages()) {
            return null;
        }
        var modalClasses = classNames('lightbox-modal', { 'lightbox-modal--loading': this.state.imageLoading });
        var classes = classNames('lightbox-image', { 'lightbox-image--single': this.isSingleImage() }, { 'lightbox-image--transitioning': this.state.transitioning }, { 'lightbox-image--with-thumbnails': this.shouldDisplayThumbnails() }, { 'lightbox-image--hide-mobile-controls': this.props.hideMobileControls });
        return (React.createElement("div", { className: classes },
            this.renderPrimarySwipeContainer(),
            this.renderPrimaryCaption(),
            this.shouldDisplayThumbnails() && this.renderThumbs(),
            this.renderImageCache(),
            !is_node_1.default && React.createElement(ReactModal, { isOpen: this.state.isOpen, onRequestClose: this.closeModal, id: this.props.id, className: modalClasses, overlayClassName: "lightbox-modal__container", parentSelector: this.outlet },
                React.createElement("div", { className: "lightbox-modal__primary", onKeyDown: this.handleKeyDown },
                    this.renderCaption(),
                    this.renderSwipeContainer()),
                this.renderThumbs(),
                this.renderControls(),
                this.renderCloseButton())));
    };
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "outlet", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "handleMainImageClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "closeModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "handleImageLoaded", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "handlePrimaryImageLoaded", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "handleKeyDown", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "loadNextImage", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "loadPrevImage", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "handleFullsizeImageClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "handleThumbClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImage.prototype, "resetTransition", null);
    LightboxImage = tslib_1.__decorate([
        react_tracking_1.default({ componentName: COMPONENT_NAME })
    ], LightboxImage);
    return LightboxImage;
}(React.Component));
exports.default = LightboxImage;
//# sourceMappingURL=lightbox_image.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/lightbox_image.js
// module id = 0F7/
// module chunks = 20 21